import AuthBoundary from "@/app/boundaries/AuthBoundary"
import DefaultBoundaries from "@/app/boundaries/DefaultBoundaries"
import UserBoundary from "@/app/boundaries/UserBoundary"
import HeaderOwner from "@/app/components/Header/HeaderOwner"
import CompanyNavLayout from "@/app/layouts/CompanyNavLayout/CompanyNavLayout"
import { CompanyNavigation, CompanyPreviewContainer, CompanySelectContainer } from "@/areas/company"
import { companyAvatarColors } from "@/constants/companyAvatarColor"
import { UserRole } from "@/entities/user"
import useSearchState from "@/utils/hooks/useSearchState"

function CompaniesPage() {
  const [companyId] = useSearchState("company-id")

  return (
    <AuthBoundary>
      <UserBoundary minRole={UserRole.StreamManager} fallback="Not enough permission">
        <CompanyNavLayout sidebar={(
          <DefaultBoundaries>
            <CompanySelectContainer />
          </DefaultBoundaries>
        )}>
          {companyId != null && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4em" }}>
              <div style={{ maxHeight: "120px" }}>
                <DefaultBoundaries>
                  <CompanyPreviewContainer theme="light" id={companyId} size="big" {...companyAvatarColors} />
                </DefaultBoundaries>
              </div>
              <CompanyNavigation companyId={companyId} />
            </div>
          )}
        </CompanyNavLayout>
      </UserBoundary>
    </AuthBoundary >
  )
}

export default CompaniesPage

CompaniesPage.header = () => <HeaderOwner />
